import ReactDOM from 'react-dom';

import ModalView from '@/components/modal/ModalView';
import useModalStore from '@/stores/modalStore';

const ModalPortal = () => {
  const { modals } = useModalStore();
  const container = document.getElementById('modal') as HTMLElement;

  return ReactDOM.createPortal(
    <div>
      {modals.map((modal) => (
        <ModalView {...modal} key={modal.type} />
      ))}
    </div>,
    container,
  );
};

export default ModalPortal;
